import { Component, OnInit } from '@angular/core';

import { RouterEvent, NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/@core/services';
import { AppNotificationService } from '../../services/app-notifications.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    isLoggedIn: boolean = false;
    userId;
    userType: string;
    currentUser: any;
    errorMessage: any;
    constructor(
        private authService: AuthService,
        private router: Router,
        private appNotificationService: AppNotificationService
    ) { }

    ngOnInit() {
        this.currentUser = this.authService.getCurrentUser();
    }
   
    logout() {
        this.authService.signOut().subscribe(
            res => {
                let data: any = res;
                // console.log(data);
                this.authService.logout();
            },
            err => {
              let error = err.error.error
              this.errorMessage = error.error
              this.appNotificationService.push(this.errorMessage, 'error');
            }
        )
    }
    

}
